export default __webpack_public_path__ + "static/media/logo-blanco.2b021a4c.png";